import {Component, OnInit} from '@angular/core';
import {LayoutService} from "../../layout.service";

declare var $: any;

@Component({
  selector: 'sa-collapse-menu',
  templateUrl: './collapse-menu.component.html'
})
export class CollapseMenuComponent {

  isCollapsed = false;

  constructor(
    private layoutService: LayoutService
  ) {
    this.layoutService.subscribe((success) => {
      this.isCollapsed =  success.menuCollapsed;
    });
  }

  onToggle() {
    this.layoutService.onCollapseMenu()
  }
}
